module.exports = __webpack_public_path__ + "static/media/trees_in_the_meadow_small.77452c1a.jpg";